import { IQueryResponse } from '@services/api';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';

import { MeetingDetailsObject } from '@components/meeting-details';
import { APICONFIG } from '@config/api.config';
import { useGetRxDb } from '@hooks/getRxdbData';
import { ProfileData } from '@services/hooks/profile';

export const useGetRBDMMeetingQuery = (
	id: string | undefined,
	type: string | undefined
): IQueryResponse<MeetingDetailsObject> => {
	const { result: profile } = useGetRxDb<ProfileData>('profile');

	const isProfileLoaded = profile && profile.length > 0;
	const userRole = isProfileLoaded ? profile[0]?.usertype_c : '';
	const isRBDM = userRole === 'RBDM';

	const fetchMeetingListData = async (): Promise<MeetingDetailsObject> => {
		if (!id) {
			throw new Error('Meeting ID is required');
		}
		let baseUrl = APICONFIG.MEETINGS_DETAILS;

		if (type === 'MDP') {
			baseUrl = APICONFIG.MDP_MEETINGS_DETAILS;
		} else if (isRBDM) {
			baseUrl = APICONFIG.MEETINGS_DETAILS_RBDM;
		}

		return APIService.getData<MeetingDetailsObject>(`${baseUrl}/${id}`);
	};

	const { data, error, isLoading, isPending, refetch, isFetching } = useQuery({
		queryKey: ['MeetingList', id, userRole],
		queryFn: fetchMeetingListData,
		refetchOnWindowFocus: false,
		retry: false,
		enabled: !!id && isProfileLoaded,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		refetch,
		isFetching,
	};
};
